import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FloorPlanDialogComponent } from './floorPlanDialog/floorPlanDialog.component';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../../../../core';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../../../core/services/tab.service';
import { environment } from '../../../../../../environments/environment';
import { DocumentDialogComponent } from './documentDialog/documentDialog.component';
import { DeletePropertyDialogComponent } from './deletePropertyDialog/deletePropertyDialog.component';

@Component({
    selector: 'app-edit-property',
    templateUrl: './edit-property.component.html',
    styleUrls: ['./edit-property.component.scss']
})

export class EditPropertyComponent implements OnInit {
    reactiveForm: any;
    selectedTermsAttachments = [];
    listingDateTimestamp = '';
    soldDateTimestamp = '';
    settledDateTimestamp = '';
    project: any;
    projectId: any;
    propertyId: any;
    projectName: any;
    projectCode: any;
    property: any;
    previousProjectId: any;
    SERVER_URL = environment.SERVER_URL;
    isLoading: boolean;
    levelRegex = /^(0|[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[g|G]|[g|G][a-c|A-C]|[l|L][g|G]|[l|L]|[b|B]|[b|B][1-5])$/;


    @Input() injectedProject: any;
    @Input() injectedProperty: any;
    @Output() changeTabEvent = new EventEmitter();
    @Output() closeDialogAfterDeletion = new EventEmitter();


    constructor(
        private dialog: MatDialog,
        private fb: FormBuilder,
        private toastService: ToastrService,
        private httpService: HttpService,
        private route: ActivatedRoute,
        private router: Router,
        private tabService: TabService
    ) {
        this.isLoading = true
        this.reactiveForm = this.fb.group({
            type: [''],
            pNumber: [''],
            lotNumber: [''],

            commission: [''],
            commissionUnit: [''],
            status: [''],
            orientation: [''],
            view: [''],
            description: [''],
            soldDate: [{ value: '', disabled: true }],
            settledDate: [{ value: '', disabled: true }],
            listingDate: [{ value: '', disabled: true }],
            level: ['0', [Validators.pattern(this.levelRegex)]],
            totalPrice: [''],
            extraCost: [''],

            // landPrice: [''],
            // housePrice: [''],

            bed: ['0'],
            bath: ['0'],
            study: ['0'],
            // livingRoom: [''],
            car: ['0'],
            storeys: ['0'],
            internalArea: [''],
            externalArea1: [''],
            externalArea2: [''],
            totalArea: [''],
            landArea: [''],

            tags: [''],

            estimatedRates: [''],
            estimatedRentalReturns: [''],
            estimatedOwnersCorporationFee: [''],
            stampDuty: [''],
            councilFee: ['']

        });
    }

    ngOnInit(): void {
        var initVal = 0;
        if (!this.injectedProject) {
            this.projectId = this.route.snapshot.paramMap.get('id');
            this.propertyId = this.route.snapshot.paramMap.get('propertyId');
            console.log(this.propertyId, this.propertyId);
            this.route.queryParams.subscribe(params => {
                console.log(params);
                this.projectCode = params.projectCode;
                this.projectName = params.projectName;
                this.project = window.history.state.project;
                console.log(this.project);
            });

        } else {
            console.log(this.injectedProject);
            this.project = this.injectedProject;
            this.projectId = this.injectedProject.id;
            this.propertyId = this.injectedProperty.id;

        }

        this.httpService.getPropertyById(this.propertyId).subscribe((res: any) => {
            console.log(res);
            this.property = res.data;
            this.reactiveForm.patchValue({
                type: this.property.projectType.id,
                status: this.property.status,
                pNumber: this.property.unitNum,
                totalPrice: this.property.price,
                extraCost: this.property.extraCost ? this.property.extraCost : '',
                bed: this.property.bedRoom,
                bath: this.property.bathRoom,
                study: this.property.studyRoom,
                car: this.property.carParking,
                storeys: this.property.storeys,
                internalArea: this.property.internalArea.toFixed(2),
                // externalArea: this.property.externalArea,
                externalArea1: this.property.externalAreas && this.property.externalAreas.externalArea1 ? this.property.externalAreas.externalArea1 : initVal.toFixed(2),
                externalArea2: this.property.externalAreas && this.property.externalAreas.externalArea2 ? this.property.externalAreas.externalArea2 : initVal.toFixed(2),
                totalArea: this.property.totalArea.toFixed(2),
                landArea: this.property.landArea ? this.property.landArea : '',
                level: this.property.level || this.property.level === 0 ? this.transformLevel(this.property.level) : '',
                listingDate: this.property.listTime ? new Date(this.property.listTime) : '',
                soldDate: this.property.soldTime ? new Date(this.property.soldTime) : '',
                settledDate: this.property.settleTime ? new Date(this.property.settleTime) : '',
                estimatedRates: this.property.estimatedRates ? this.property.estimatedRates : '',
                estimatedRentalReturns: this.property.estimatedRentalReturns ? this.property.estimatedRentalReturns : '',
                estimatedOwnersCorporationFee: this.property.estimatedOwnersCorporationFee ? this.property.estimatedOwnersCorporationFee : '',
                orientation: this.property.aspect ? this.property.aspect : '',
                view: this.property.view ? this.property.view : '',
                description: this.property.notes ? this.property.notes : '',
                lotNumber: this.property.lotNum ? this.property.lotNum : '',
                commission: this.property.commissionFee ? this.property.commissionFee : '',
                commissionUnit: this.property.commissionFeeUnit ? this.property.commissionFeeUnit : '%',
                stampDuty: this.property.stampDuty ? this.property.stampDuty : '',
                councilFee: this.property.councilFee ? this.property.councilFee : ''
            });
            this.isLoading = false
        });

    }

    valueChange($event) {
        this.reactiveForm.patchValue({
            internalArea: parseFloat(this.reactiveForm.get('internalArea').value).toFixed(2),
            externalArea1: parseFloat(this.reactiveForm.get('externalArea1').value).toFixed(2),
            externalArea2: parseFloat(this.reactiveForm.get('externalArea2').value).toFixed(2),
        });
        this.reactiveForm.patchValue({
            totalArea: (
                parseFloat(this.reactiveForm.get('internalArea').value)
                + parseFloat(this.reactiveForm.get('externalArea1').value)
                + parseFloat(this.reactiveForm.get('externalArea2').value)
            ).toFixed(1)
        });
    }
    valueChange2($event) {
        this.reactiveForm.patchValue({
            bath: parseFloat(this.reactiveForm.get('bath').value).toFixed(2),
            car: parseFloat(this.reactiveForm.get('car').value).toFixed(2),
        });
    }

    getListingDate(event) {
        this.listingDateTimestamp = new Date(event.value).getTime().toString();
    }

    getSoldDate(event) {
        this.soldDateTimestamp = new Date(event.value).getTime().toString();
    }

    getSettledDate(event) {
        this.settledDateTimestamp = new Date(event.value).getTime().toString();
    }

    openFloorPlanDialog() {
        // 使用 ?
        // const project = window.history.state.project;

        const dialogRef = this.dialog.open(FloorPlanDialogComponent, {
            disableClose: true,
            width: '80%',
            data: {
                projectId: this.project.id,
                propertyId: this.propertyId,
                floorPlan: this.property.floorPlan ? this.property.floorPlan : null,
                projectCode: this.project.projectCode,
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result) {
                this.property.floorPlan = result.attachedFloorPlan;
            }
            this.closeDialogAfterDeletion.emit({ value: true });
        });
    }

    updateProperty() {
        if (this.reactiveForm.invalid) {
            return;
        }
        const fd = new FormData();
        if (this.reactiveForm.get('type').value !== this.property.projectType.id) {
            fd.append('projectTypeId', this.reactiveForm.get('type').value);
        }
        if (this.reactiveForm.get('status').value !== this.property.status) {
            fd.append('status', this.reactiveForm.get('status').value);
        }
        if (this.soldDateTimestamp !== this.property.soldTime) {
            fd.append('soldTime', this.soldDateTimestamp);
        }
        if (this.settledDateTimestamp !== this.property.settleTime) {
            fd.append('settleTime', this.settledDateTimestamp);
        }
        if (this.listingDateTimestamp !== this.property.listTime) {
            fd.append('listTime', this.listingDateTimestamp);
        }
        if (this.reactiveForm.get('pNumber').value !== this.property.unitNum) {
            fd.append('unitNum', this.reactiveForm.get('pNumber').value);
        }
        if (this.reactiveForm.get('level').value !== 0 && this.reactiveForm.get('level').value !== this.property.level) {
            if (!isNaN(this.reactiveForm.get('level').value)) {
                fd.append('level', this.reactiveForm.get('level').value);
            } else {
                console.log('bbb');
                switch (this.reactiveForm.get('level').value.toUpperCase()) {
                    case 'GC':
                        fd.append('level', '-1');
                        break;
                    case 'GB':
                        fd.append('level', '-2');
                        break;
                    case 'GA':
                        fd.append('level', '-3');
                        break;
                    case 'G':
                        fd.append('level', '-4');
                        break;
                    case 'LG':
                        fd.append('level', '-5');
                        break;
                    case 'L':
                        fd.append('level', '-6');
                        break;
                    case 'B':
                        fd.append('level', '-7');
                        break;
                    case 'B1':
                        fd.append('level', '-8');
                        break;
                    case 'B2':
                        fd.append('level', '-9');
                        break;
                    case 'B3':
                        fd.append('level', '-10');
                        break;
                    case 'B4':
                        fd.append('level', '-11');
                        break;
                    case 'B5':
                        fd.append('level', '-12');
                        break;
                    default:
                        break;
                }
            }
        }
        if (this.reactiveForm.get('lotNumber').value !== this.property.lotNum) {
            fd.append('lotNum', this.reactiveForm.get('lotNumber').value);
        }

        if (this.reactiveForm.get('commission').value !== this.property.commissionFee && this.reactiveForm.get('commission').value) {
            fd.append('commissionFee', this.reactiveForm.get('commission').value);
        }
        // max-width: 20
        if (this.reactiveForm.get('commissionUnit').value !== this.property.commissionFeeUnit) {
            fd.append('commissionFeeUnit', this.reactiveForm.get('commissionUnit').value);
        }

        if (this.reactiveForm.get('totalPrice').value !== this.property.price) {
            fd.append('price', this.reactiveForm.get('totalPrice').value);
        }
        if (this.reactiveForm.get('extraCost').value !== this.property.extraCost && this.reactiveForm.get('extraCost').value) {
            fd.append('extraCost', this.reactiveForm.get('extraCost').value);
        }
        if (this.reactiveForm.get('bed').value !== this.property.bedRoom) {
            fd.append('bedRoom', this.reactiveForm.get('bed').value);
        }
        if (this.reactiveForm.get('bath').value !== this.property.bathRoom) {
            fd.append('bathRoom', this.reactiveForm.get('bath').value);
        }
        if (this.reactiveForm.get('car').value !== this.property.carParking) {
            fd.append('carParking', this.reactiveForm.get('car').value);
        }
        if (this.reactiveForm.get('study').value !== this.property.studyRoom) {
            fd.append('studyRoom', this.reactiveForm.get('study').value);
        }
        if (this.reactiveForm.get('storeys').value !== this.property.storeys) {
            fd.append('storeys', this.reactiveForm.get('storeys').value);
        }
        if (this.reactiveForm.get('internalArea').value !== this.property.internalArea) {
            fd.append('internalArea', this.reactiveForm.get('internalArea').value);
        }
        if (this.reactiveForm.get('totalArea').value !== this.property.totalArea) {
            fd.append('totalArea', this.reactiveForm.get('totalArea').value);
        }
        console.log(this.reactiveForm.get('externalArea1').value);
        console.log(this.reactiveForm.get('externalArea2').value);
        if ((this.reactiveForm.get('externalArea1').value !== this.property.externalArea?.externalArea1 || this.reactiveForm.get('externalArea2').value !== this.property.externalArea?.externalArea2)) {
            fd.append('externalAreas', JSON.stringify({
                externalArea1: this.reactiveForm.get('externalArea1').value,
                externalArea2: this.reactiveForm.get('externalArea2').value,
            }));
        }

        if (this.reactiveForm.get('landArea').value !== this.property.totalArea && this.reactiveForm.get('landArea').value) {
            fd.append('landArea', this.reactiveForm.get('landArea').value);
        }
        if (this.reactiveForm.get('orientation').value !== this.property.aspect) {
            fd.append('aspect', this.reactiveForm.get('orientation').value);
        }
        if (this.reactiveForm.get('view').value !== this.property.view) {
            fd.append('view', this.reactiveForm.get('view').value);
        }
        console.log(this.reactiveForm.get('description').value !== this.property.notes);
        if (this.reactiveForm.get('description').value !== this.property.notes) {
            fd.append('notes', this.reactiveForm.get('description').value);
        }
        if (this.reactiveForm.get('estimatedRates').value !== this.property.estimatedRates && this.reactiveForm.get('estimatedRates').value) {
            fd.append('estimatedRates', this.reactiveForm.get('estimatedRates').value);
        }
        if (this.reactiveForm.get('estimatedRentalReturns').value !== this.property.estimatedRentalReturns && this.reactiveForm.get('estimatedRentalReturns').value) {
            fd.append('estimatedRentalReturns', this.reactiveForm.get('estimatedRentalReturns').value);
        }
        if (this.reactiveForm.get('estimatedOwnersCorporationFee').value !== this.property.estimatedOwnersCorporationFee && this.reactiveForm.get('estimatedOwnersCorporationFee').value) {
            fd.append('estimatedOwnersCorporationFee', this.reactiveForm.get('estimatedOwnersCorporationFee').value);
        }
        if (this.reactiveForm.get('stampDuty').value !== this.property.stampDuty && this.reactiveForm.get('stampDuty').value) {
            fd.append('stampDuty', this.reactiveForm.get('stampDuty').value);
        }
        if (this.reactiveForm.get('councilFee').value !== this.property.councilFee && this.reactiveForm.get('councilFee').value) {
            fd.append('councilFee', this.reactiveForm.get('councilFee').value);
        }


        this.httpService.updateProperty(this.propertyId, fd).subscribe((res: any) => {
            // console.log();
            if (res.code === 1) {
                // 切换到edit project页面的property tab
                // if (!this.injectedProperty) {
                //     this.router.navigateByUrl('/projects/' + this.projectId + '/edit');
                // }
                // this.changeTabEvent.emit({value: 4});

                // 统一跳转到 project 详情
                // this.router.navigateByUrl('/projects/' + this.project.id);
                this.closeDialogAfterDeletion.emit({ value: true, property: res.data });


                this.tabService.tabIndex = 5;
                this.toastService.success('The property has been updated');
            } else if (res.code === 0) {
                this.toastService.error('Failed to update this property');
            }
        });
    }


    openDocumentDialog() {
        const dialogRef = this.dialog.open(DocumentDialogComponent, {
            width: '80%',
            disableClose: true,
            data: {
                documents: this.property.documents,
                propertyId: this.property.id,
                unitNumber: this.property.unitNum,
                projectCode: this.project.projectCode
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            this.property.documents = result.documents;
        });
    }

    transformLevel(level) {
        switch (level) {
            case -1:
                return 'GC';
            case -2:
                return 'GB';
            case -3:
                return 'GA';
            case -4:
                return 'G';
            case -5:
                return 'LG';
            case -6:
                return 'L';
            case -7:
                return 'B';
            case -8:
                return 'B1';
            case -9:
                return 'B2';
            case -10:
                return 'B3';
            case -11:
                return 'B4';
            case -12:
                return 'B5';
            default:
                return level;
        }
    }

    openDeletePropertyDialog() {
        const dialogRef = this.dialog.open(DeletePropertyDialogComponent, {
            width: '400px',
            disableClose: true,
            data: {
                propertyId: this.property.id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && result.result === 1) {
                if (!this.injectedProperty) {
                    this.router.navigateByUrl('/projects/' + this.projectId + '/edit');
                } else {
                    this.closeDialogAfterDeletion.emit({ value: true });
                }
            }
        });
    }

  validateInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(input.value)) {
      input.value = '0';
    }
  }
}
